import merge from 'lodash/merge';
import { pure, compose } from 'recompose';
import React from 'react';
import * as Prism from 'prismjs';

// Fix for Uncaught ReferenceError: Prism is not defined in RTE
if (typeof window !== 'undefined' && typeof window.Prism === 'undefined') {
  /* istanbul ignore next */
  window.Prism = Prism;
}
import type { QnAStateType } from '../reducers';
import { QuestionStyleContext, defaultQuestionStyles } from '../question-style-context';
import { getTopQuestionIds } from '../reducers/selectors';
import Question from './questions/Question';
import QuestionList from './common/QuestionList';
const Questions = ({
  taskIndex,
  state,
  updateAnswers,
  selectAnswer,
  removeAnswer,
  shouldForceUpdateRTEAnswer,
  setForceUpdateRTEAnswer,
  updateNote,
  showAnswerAsSelectLimit,
  styleOverrides,
  isComposeMode = false,
  readOnly = false
}: {
  taskIndex: number;
  state: QnAStateType;
  updateAnswers: Function;
  selectAnswer: Function;
  removeAnswer: Function;
  shouldForceUpdateRTEAnswer?: boolean;
  setForceUpdateRTEAnswer?: (prevValue: boolean) => void;
  updateNote?: Function | null;
  showAnswerAsSelectLimit?: number | null;
  styleOverrides?: any;
  isComposeMode?: boolean;
  readOnly?: boolean;
}) => {
  const styles = merge({}, defaultQuestionStyles, styleOverrides);
  const topQuestionIds = getTopQuestionIds(state);
  return <QuestionStyleContext.Provider value={styles}>
      <QuestionList>
        {topQuestionIds.map(id => {
        return <Question key={`taskIndex-${taskIndex}-question-${id}`} questionId={id} state={state} updateAnswers={updateAnswers} selectAnswer={selectAnswer} removeAnswer={removeAnswer} updateNote={updateNote} showAnswerAsSelectLimit={showAnswerAsSelectLimit} isComposeMode={isComposeMode} shouldForceUpdateRTEAnswer={shouldForceUpdateRTEAnswer} setForceUpdateRTEAnswer={setForceUpdateRTEAnswer} readOnly={readOnly} />;
      })}
      </QuestionList>
    </QuestionStyleContext.Provider>;
};
export default compose(pure)(Questions);